export const interactionModeRequestedAttributes = (
	interactionModeRequested?: string,
): { interactionModeRequested?: string } =>
	interactionModeRequested ? { interactionModeRequested } : {};
